module.exports = __webpack_public_path__ + "static/media/SUTER-BNB.aeed2183.svg";